@if (error()) {
  <glxy-empty-state>
    <glxy-empty-state-hero>
      <mat-icon color="warn">error</mat-icon>
    </glxy-empty-state-hero>
    <glxy-empty-state-title>{{ 'INBOX.SOMETHING_WENT_WRONG' | translate }}</glxy-empty-state-title>
    @if (customErrorMessage()) {
      <p>{{ customErrorMessage()! | translate }}</p>
    }
  </glxy-empty-state>
}
